<template>
  <div class="login">
    <div class="wrapper">
      <div class="logo-wrapper">
        <img
          src="/images/logo.svg"
          class="logo-wrapper__image"
          alt="logo"
        >
      </div>
      <form
        class="form"
        @submit.prevent="onSubmit"
      >
        <div class="form__texts">
          <p class="form__title h3">Восстановление пароля</p>
          <p class="form__desc">
            Введите ваш адрес email.<br>
            Вы получите email сообщение с инструкциями<br>
            по сбросу пароля.
          </p>
        </div>

        <BaseInput
          v-model="form.email"
          class="form__input"
          placeholder="E-mail"
        />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.email.email.$invalid">
          Не валидный адрес почты.
        </InvalidFeedback>
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.email.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>

        <BaseButton
          block
          class="form__button"
        >
          СБРОСИТЬ
        </BaseButton>
      </form>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'

import BaseInput from '@/components/Base/BaseInput'
import BaseButton from '@/components/Base/BaseButton'
import InvalidFeedback from '@/components/InvalidFeedback'

export default {
  name: 'login',
  components: {
    InvalidFeedback,
    BaseButton,
    BaseInput
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      form: {
        email: ''
      }
    }
  },
  methods: {
    async onSubmit () {
      if (this.v$.form.$invalid) {
        this.v$.form.$touch()
        return
      }

      try {
        await this.$api.auth.reset(this.form.email)
        alert('Мы отправили письмо на вашу почту.')
      } catch (e) {
        console.log(e)
      }
    }
  },
  validations () {
    return {
      form: {
        email: {
          email,
          required
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  .wrapper {
    width: 440px;
  }

  .logo-wrapper {
    &__image {
      display: block;
      width: 229px;
    }
  }

  .form {
    margin-top: 20px;
    background: #1D1D1D;
    border-radius: 30px;
    padding: 28px;

    &__texts {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__title {
      margin-bottom: 16px;
    }

    &__desc {
      margin-bottom: 28px;
      color: #E0E0E0;
    }

    &__input {
      margin-bottom: 14px;
      height: 55px;
    }

    &__button {
      height: 60px;
      margin-top: 30px;
    }
  }
}
</style>
